import { Box, Switch, Typography } from "@mui/material";

const CustomSwitch = ({
  checked,
  onChange,
  disabled,
  name,
  value,
  leftText = "Enabled",
  rightText = "Disabled",
}: {
  checked: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  name: string;
  value?: string;
  leftText?: string;
  rightText?: string;
}) => {
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      <Switch
        name={name}
        value={value}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        sx={{
          width: 42,
          height: 24,
          padding: 0,

          "& .MuiSwitch-switchBase": {
            padding: 0,
            margin: "2px",
            transitionDuration: "200ms",
            "&.Mui-checked": {
              transform: "translateX(18px)",
              color: "#fff",
              "& + .MuiSwitch-track": {
                backgroundColor: "#0d3b66",
                opacity: 1,
                border: 0,
              },
              "&.Mui-disabled + .MuiSwitch-track": {
                backgroundColor: "#0d3b66",
                cursor: "not-allowed",
              },
            },
            // "&.Mui-focusVisible .MuiSwitch-thumb": {
            //   border: "2px solid #000",
            // },
            // "&.Mui-disabled .MuiSwitch-thumb": {
            //   color: "#f3f4f6",
            // },
            // "&.Mui-disabled + .MuiSwitch-track": {
            //   opacity: 0.3,
            // },
          },
          "& .MuiSwitch-thumb": {
            boxSizing: "border-box",
            width: 20,
            height: 20,
            backgroundColor: "#fff",
            boxShadow: "none",
            transition: "transform 200ms cubic-bezier(0.4, 0, 0.2, 1)",
          },
          "& .MuiSwitch-track": {
            borderRadius: 24,
            backgroundColor: "#e5e7eb",
            opacity: 1,
            transition: "background-color 200ms cubic-bezier(0.4, 0, 0.2, 1)",
          },
        }}
      />
      <Typography
        variant="body2"
        sx={{
          fontSize: "14px",
          fontWeight: 500,
          color: checked ? "#0d3b66" : "#71717a",
        }}
      >
        {checked ? leftText : rightText}
      </Typography>
    </Box>
  );
};

export default CustomSwitch;
